export const esCommon = {
  close: 'Cerrar',
  account: 'Cuenta',
  back: 'Volver',
  openMenu: 'Abrir menú',
  closeMenu: 'Cerrar menú',
  explore: 'Explorar',
  explorer: 'Explorer',
  token: 'Token',
  network: 'Red',
  symbol: 'Símbolo',
  decimals: 'Decimales',
  fee: 'Comisión',
  feeTier: 'Fee tier',
  protocol: 'Protocolo',
  all: 'Todos',
  results: 'Resultados',
  today: 'Hoy',
  yesterday: 'Ayer',
  noDate: 'Sin fecha',
  transaction: 'Transacción',
  confirmed: 'Confirmada',
  pending: 'Pendiente',
  confirmedPlural: 'Confirmados',
  pendingPlural: 'Pendientes',
  assetCount: (count: number) => `${count} activo${count === 1 ? '' : 's'}`,
  goToExplore: 'Ir a Explorar',
  viewProfile: 'Ver ficha',
  copyAddressCopied: (label: string) => `${label} copiada`,
  marketDataEmpty: 'No hay datos de mercado disponibles.',
  website: 'Sitio web',
  whitepaper: 'Whitepaper',
  links: 'Enlaces',
  aboutProject: 'Acerca del proyecto',
  info: 'Info',
  chart: 'Gráfica',
  price: 'Precio',
  invert: 'Invertir',
  invertQuote: 'Invertir cotización',
  invertPair: 'Invertir par',
  loadingQuote: 'Cargando cotización…',
  loading: 'Cargando…',
  loadingPool: 'Cargando pool…',
  noOnChainPool: 'Sin pool on-chain para este par',
  noPool: 'Sin pool',
  canonicalSource: 'Fuente canónica:',
  documents: 'Documentos',
  reading: 'Lectura',
  downloadTxt: 'Descargar .txt',
  downloadTxtAria: 'Descargar documento en .txt',
  documentUnavailableLocale: 'Documento no disponible en este idioma.',
  trade: 'Trade',
  addLiquidity: 'Añadir liquidez',
  removeLiquidity: 'Retirar liquidez',
  token0: 'Token 0',
  token1: 'Token 1',
  token2: 'Token 2',
  tokenA: 'Token A',
  tokenB: 'Token B',
  selectToken: 'Seleccionar token',
  selectTokenA: 'Seleccionar token A',
  selectTokenB: 'Seleccionar token B',
  selectToken1: 'Seleccionar token 1',
  selectToken2: 'Seleccionar token 2',
  poolV2: 'Pool V2',
  spotPrice: 'Precio spot',
  apy: 'APY',
  onChainData: 'Datos on-chain',
  contract: 'Contrato',
  wethContract: 'Contrato WETH',
  viewContractExplorer: 'Ver contrato en explorer',
  viewPairExplorer: 'Ver par en explorer',
  copyContractAddress: 'Copiar dirección del contrato',
  copyWethAddress: 'Copiar dirección del contrato WETH',
  copyTokenContract: (symbol: string) => `Copiar contrato de ${symbol}`,
  copyPairContract: 'Copiar contrato del par',
  pairContract: 'Contrato del par',
  tokenProfileSheet: (symbol: string) => `Ficha ${symbol}`,
  noPublicLinks: 'Sin enlaces públicos registrados para este token.',
  inCirculationSince: (date: string) => `En circulación desde ${date}`,
  marketCap: 'Market cap',
  volume24h: 'Volumen 24h',
  supply: 'Supply',
  holders: 'Holders',
  overview: 'Overview',
  liquidity: 'Liquidez',
  reservesAndContracts: 'Reservas y contratos',
  share: 'Share',
  myPositions: 'Mis posiciones',
  positions: 'Posiciones',
  tvlFee: (tvl: string, fee: string) => `TVL ${tvl} · Fee ${fee}`,
  volPrefix: (value: string) => `Vol ${value}`,
  chartTimeframe: 'Temporalidad del gráfico',
  hideChart: 'Ocultar gráfico',
  showChart: 'Mostrar gráfico',
  numericKeypad: 'Teclado numérico',
  invertSwapDirection: 'Invertir sentido del intercambio',
  invertSwapDirectionAndQuote: 'Invertir sentido del intercambio y cotización',
  invertMarketQuoteRef: 'Invertir referencia de cotización de mercado',
  invertMarketRef: 'Invertir referencia de mercado',
  pairNotInMarketIndex: 'Par no disponible en el índice de mercado.',
  transactionRejectedPreview: 'Transacción rechazada (vista previa)',
} as const
